import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UserStats } from 'src/app/models/community';
import { CommunityService } from 'src/app/services/community.service';
import { I18nService } from 'src/app/services/i18n.service';

@Component({
  selector: 'app-user-stats',
  templateUrl: './user-stats.component.html',
  styleUrls: ['./user-stats.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserStatsComponent implements OnInit {

  stats: UserStats | null = null;
  loading = true;
  error = '';

  constructor(private communityService: CommunityService, public i18n: I18nService) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = '';
    this.communityService.stats().subscribe({
      next: stats => {
        this.stats = stats;
        this.loading = false;
      },
      error: err => {
        this.error = err || this.i18n.t('account.loadError');
        this.loading = false;
      }
    });
  }
}
